export default __webpack_public_path__ + "af75befedf9795aeae68eb4a36a09261.png";